<h1 mat-dialog-title>
  Velg felt for {{data.column}}
</h1>

<div mat-dialog-content>
  <app-import-field-select (importFieldSelected)="selectedField = $event"></app-import-field-select>
</div>

<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">
    Avbryt
  </button>

  <button mat-button [mat-dialog-close]="selectedField">
    Ok
  </button>
</div>
